import gql from 'graphql-tag';
import { apollo } from 'src/features';

const query = gql`
query unitsDepartments {
  unitsDepartments {
    id
    name
    emails
    teams {
      id
      name
    }
    allTeamsOn
  }
}`;

function getUnitsDepartments() {
  return apollo.client.query({
    query,
    fetchPolicy: 'network-only',
  }).then((res) => res.data.unitsDepartments);
}

export default getUnitsDepartments;
